import { useState } from "react";
import Top from "../components/templates/top";
import listText from "../utils/dictionaries/dictionary-suggestion-capture-receipt";
import { useNavigate } from "react-router-dom";
import Button from "../components/atoms/button";
import Link from "../components/atoms/link";
import Image from "../components/atoms/image";
import voucherExample from "../assets/images/voucher-example.png";
import Paragraph from "../components/atoms/paragraph";
import InformationSection from "../components/molecules/information-section";

const SuggestionCaptureReceipt = () => {
  const navigate = useNavigate();
  const [btnColor, setBtnColor] = useState("button-enabled");
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);

  const continueProcess = () => {};

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/SuggestionCaptureReceipt",
        step: "CONTINUE_AFTER",
        data: {},
      },
    });
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_0.mainText}
          subTitle={listText.text_1.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={""}
          classTitleImage={"ms-2"}
          classHeader={"mt-2 mb-3"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"45%"}
          comeFrom={"/SuggestionCaptureReceipt"}
          onClickGoBackIcon={() => navigate("/ProofAddressCondition")}
        />
        <div className="p-3">
          <div className="text-center">
            <Image
              srcImage={voucherExample}
              className={""}
              alt={""}
              dataBsDismiss={""}
              styleImg={undefined}
              onClick={undefined}
            />
          </div>
          <div style={{height: 80,  display: "flex", width: 376, padding: 16, alignItems: "flex-start", gap: 8, background: "#F7F7F7" }} className="my-3">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22.0015C14.6522 22.0015 17.1957 20.9479 19.0711 19.0725C20.9464 17.1972 22 14.6536 22 12.0015C22 9.3493 20.9464 6.80576 19.0711 4.9304C17.1957 3.05503 14.6522 2.00146 12 2.00146C9.34784 2.00146 6.8043 3.05503 4.92893 4.9304C3.05357 6.80576 2 9.3493 2 12.0015C2 14.6536 3.05357 17.1972 4.92893 19.0725C6.8043 20.9479 9.34784 22.0015 12 22.0015ZM12.9375 7.00146V7.93896V12.314V13.2515H11.0625V12.314V7.93896V7.00146H12.9375ZM11.0625 16.3765V14.5015H12.9375V16.3765H11.0625Z" fill="#E42A23"/>
            </svg>
            <Paragraph text={"No fue posible validar tu comprobante, vuelve a intentarlo."} className={""} styleParagraph={undefined} />
          </div>
          <div className="">
            {listText.arrayTexts.map((item: any) => {
              return (
                <InformationSection
                  key={item.description}
                  titleText={item.title}
                  paragraphText={item.description}
                  srcImage={item.icon}
                  columnA={"col-1 p-0"}
                  columnB={"col-11 align-self-center"}
                  titleClass={""}
                  paragraphClass={"ms-1 mb-0 mt-auto"}
                  styleParagraph={{ fontSize: "14px" }}
                  classNameImg={"pt-0"}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <div className="wrapping-box-container">
          <div id="main-interface">
            <Button
              text={"Reintentar"}
              divClassName={"d-grid gap-2"}
              buttonClassName={`${btnColor} w-100 place-content-center align-self-center`}
              spinner={activeSpinner}
              onClick={() => navigate("/ProofAddressCondition")}
              disabled={disabledButton}
              dataBsDismiss={undefined}
            />
            <div className="text-center mt-3">
              <Link
                text={listText.text_24.mainText}
                url={null}
                styleLink={{
                  color: "#5A6172",
                  lineHeight: "16px",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={followLaterAction}
                className={""}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuggestionCaptureReceipt;
